import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { serverFetch } from "@server";
import { Button, DatePicker, Form, Input, message } from "antd";
import { fmtDateTimeFull } from "@extensions/utils";
import dayjs from "dayjs";
import { useViewportBreakpoint } from "../../hooks/useViewportBreakpoint";

const CompanyMain = () => {
  const viewport = useViewportBreakpoint();
  const isMobile = viewport === "mobile";
  const [item, setItem] = useState();
  const [loading, setLoading] = useState();
  const [form] = Form.useForm();
  const [passwordSection, setPasswordSection] = useState(false);
  const [passData, setPassData] = useState({ userName: null, pass: null, passSettingDate: null });
  const [newPassword, setNewPassword] = useState("");
  const [passwordLoading, setPasswordLoading] = useState(false);
  const companyMainScrollRef = useRef(null);

  useLayoutEffect(() => {
    if (!isMobile || !passwordSection) return;
    const el = companyMainScrollRef.current;
    if (!el) return;
    el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
  }, [isMobile, passwordSection]);

  const getData = () => {
    setLoading(true);
    serverFetch("company")
      .then(data => {
        const newData = {...data, supportFinishDate: data.supportFinishDate ? dayjs(data.supportFinishDate) : null};
        setItem(newData);
        form.setFieldsValue(newData);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, []);

  const onValuesChange = value => setItem({...item, ...value});

  const onSave = () => {
    setLoading(true);
    serverFetch("company", { method: "PUT", bodyData: item })
      .then(() => setLoading(false))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const getOldCloudPassword = () => {
    setPasswordLoading(true);
    serverFetch("company/password")
      .then(data => {
        setPassData({ userName: data.userName ?? "", pass: data.pass ?? "", passSettingDate: data.passSettingDate ?? null });
        setPasswordSection(true);
        setPasswordLoading(false);
      })
      .catch(e => {
        setPasswordLoading(false);
        message.error(e.userMessage);
      });
  };

  const setOldCloudPassword = () => {
    setPasswordLoading(true);
    serverFetch("company/password", {
      method: "PUT",
      bodyData: { Password: newPassword, userName: passData.userName },
    })
      .then(data => {
        setPassData({ userName: data.userName ?? passData.userName, pass: data.pass ?? "", passSettingDate: data.passSettingDate ?? null });
        setNewPassword("");
        setPasswordLoading(false);
        message.success("Пароль установлен");
      })
      .catch(e => {
        setPasswordLoading(false);
        message.error(e.userMessage);
      });
  };

  return (
    <div className="company-main" ref={companyMainScrollRef}>
    <Form
      form={form}
      onValuesChange={onValuesChange}
      layout={isMobile ? "vertical" : "horizontal"}
      {...(isMobile
        ? { labelCol: { span: 24 }, wrapperCol: { span: 24 } }
        : { labelCol: { span: 6 }, wrapperCol: { span: 18 } })}
      colon={false}
      disabled={loading}
      style={{ maxWidth: isMobile ? "100%" : 500, width: "100%" }}
    >
      <Form.Item label="#"><Input value={item?.id} disabled/></Form.Item>
      <Form.Item label="Наименование" name="name"><Input /></Form.Item>
      <Form.Item label="Регистрация"><Input value={fmtDateTimeFull(item?.regDateTime)} disabled/></Form.Item>
      <Form.Item label="Адрес" name="adres"><Input /></Form.Item>
      <Form.Item label="Телефоны" name="phone"><Input /></Form.Item>
      <Form.Item label="Сотрудник" name="sotrName"><Input /></Form.Item>
      <Form.Item label="Почта" name="email"><Input /></Form.Item>
      <Form.Item className="company-main-subscription-item" label="Подписка" name="supportFinishDate">
        <DatePicker disabled format="DD.MM.YYYY" />
      </Form.Item>
      <Form.Item label={isMobile ? null : " "}>
        <Button className="misoft-btn" onClick={onSave}>
          Сохранить
        </Button>
      </Form.Item>
      <Form.Item label=" ">
        <Button type="default" onClick={getOldCloudPassword} loading={passwordLoading}>
          Получить пароль старого облака
        </Button>
      </Form.Item>
      {passwordSection && (
        <>
          <Form.Item label="Логин" colon={false}>
            <Input
              value={passData.userName ?? ""}
              readOnly={!!(passData.userName && passData.userName.trim())}
              onChange={e => setPassData(prev => ({ ...prev, userName: e.target.value }))}
              placeholder={!(passData.userName && passData.userName.trim()) ? "Введите логин" : undefined}
            />
          </Form.Item>
          <Form.Item label="Пароль (текущий)" colon={false}>
            <Input.Password value={passData.pass ?? ""} readOnly autoComplete="off" />
          </Form.Item>
          <Form.Item label="Дата установки" colon={false}>
            <Input value={passData.passSettingDate ? fmtDateTimeFull(passData.passSettingDate) : ""} readOnly />
          </Form.Item>
          <Form.Item label="Новый пароль" colon={false}>
            <Input.Password
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              placeholder="Введите новый пароль"
              autoComplete="new-password"
            />
          </Form.Item>
          <Form.Item label=" ">
            <Button type="primary" onClick={setOldCloudPassword} loading={passwordLoading} disabled={!newPassword.trim()}>
              Установить пароль
            </Button>
          </Form.Item>
        </>
      )}
    </Form>
    </div>
  );
};

export default CompanyMain;